module.exports = __webpack_public_path__ + "static/4-64285fe18d85a6ea627a51bb2d5f0a4b.jpg";